import { render } from "./UpdatePassword.vue?vue&type=template&id=f7481a5c"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"
script.render = render

export default script